import React from 'react';
import Position from './Position';
import LeadSource from './LeadSource';
import PhaseProspect from './PhaseProspect';
import UpdateScoreButton from './UpdateScoreButton';
import InflowSeason from './InflowSeason';
import ProspectTag from './ProspectTag';
import Section from './Section';
import MailClickedAt from './MailClickedAt';
import MailOpenedAt from './MailOpenedAt';
import LostAt from './LostAt';
import TrackedAt from './TrackedAt';

export default () => {
  return (
    <div className="flex flex-col gap-4">
      <UpdateScoreButton />
      <Position />
      <Section />
      <LeadSource />
      <PhaseProspect />
      <ProspectTag />
      <InflowSeason />
      <LostAt />
      <TrackedAt />
      <MailClickedAt />
      <MailOpenedAt />
    </div>
  );
};
